module.exports = __webpack_public_path__ + "img/ic-complete.d9d590fe.svg";